// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__aMxra","rotation":"SmallLoader_rotation__nf94H"};